import classNames from "classnames/bind";
import LinkWrap from "../../../shared/LinkWrap/component";
import { NavLinkProps } from "../interface";
import classes from "./navLink.module.scss";

const NavLink = (props: NavLinkProps) => {
    const {
        label,
        url,
        external,
        featureAttribution,
        orientation = "",
        theme = "",
        ...rest
    } = props;

    const cx = classNames.bind(classes);
    const navLinkClasses = cx({
        navigation__navLink: true,
        [orientation]: !!orientation,
        [theme]: !!theme,
    });

    return (
        <span className={navLinkClasses}>
            <LinkWrap
                url={url}
                external={external}
                featureAttribution={featureAttribution}
                {...rest}
            >
                {label}
            </LinkWrap>
        </span>
    );
};

export default NavLink;
